/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Box, Divider, Typography, Collapse } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import vajralog from "../assets/images/vajra_logo.svg";
import { useUser } from "../context/AuthContext";
import FeatureLockedModal from "../Components/Common/FeatureLockedModal";

const SidebarLayout = ({ elements }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useUser();
  const [openSections, setOpenSections] = useState({});
  const [featureLockedModal, setFeatureLockedModal] = useState(false);
 console.log(user, "elements From LayoutFunctions");
  useEffect(() => {
    const initialOpenSections = {};
    elements.forEach((section) => {
      if (section.collapse) {
        const isActive = section.subData?.some((sub) =>
          location.pathname.startsWith(sub.path)
        );
        if (isActive) {
          initialOpenSections[section.heading] = true;
        }
      }
    });

    setOpenSections(initialOpenSections);
  }, [elements, location.pathname]);

  const toggleSection = (heading) => {
    setOpenSections((prev) => ({
      ...prev,
      [heading]: !prev[heading],
    }));
  };

  // Trial user restrictions
  const isTrialUser = user?.isTrialUser;
  const allowedHeadings = ["Overview", "Environment", "Setup"];
  const allowedSubHeadings = ["GHG Accounting"];
  const allowedSetupSubHeadings = ["Masters", "Roles and Permissions", "Facility Master"];
  const allowedSubChildren = ["Scope 1", "Scope 2"];

  // Helper to check if heading is enabled
  const isHeadingEnabled = (heading) => {
    if (!isTrialUser) return true;
    return allowedHeadings.includes(heading);
  };

  // Helper to check if sub-item is enabled
  const isSubDataEnabled = (item, sectionHeading) => {
    if (!isTrialUser) return true;
    if (sectionHeading === "Setup") {
      return allowedSetupSubHeadings.includes(item.subHeading || item.primary);
    }
    return allowedSubHeadings.includes(item.subHeading || item.primary);
  };

  // Helper to check if subChild is enabled
  const isSubChildEnabled = (subItem) => {
    if (!isTrialUser) return true;
    return allowedSubChildren.includes(subItem.primary);
  };

  const renderLink = (label, icon, path, isActive, nested = false, disabled = false) => (
    <a
      href={disabled ? "#" : path}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          setFeatureLockedModal(true);
        }
      }}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "0.4rem 0.75rem",
        marginLeft: nested ? "2.5rem" : "0.75rem",
        marginRight: "0.75rem",
        borderRadius: "4px",
        textDecoration: "none",
        color: disabled ? "#999" : isActive ? "#fff" : "#000",
        backgroundColor: disabled ? "rgb(239, 238, 238)" : isActive ? "rgba(72, 130, 87, 1)" : "transparent",
        transition: "all 0.3s ease",
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      <Box
        component="img"
        src={icon}
        alt="icon"
        sx={{
          width: "20px",
          height: "20px",
          marginRight: "8px",
          filter: disabled ? "invert(0)" : isActive ? "invert(1)" : "invert(0)",
        }}
      />
      <Typography
        style={{
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "24px",
        }}
      >
        {label}
      </Typography>
    </a>
  );

  const renderSidebarItems = () =>
    elements.map((section, index) => {
      const sectionIsActive = location.pathname.startsWith(section.path);
      const isSectionDisabled = !isHeadingEnabled(section.heading);

      return (
        <div
          key={index}
          style={{
            fontFamily: "Inter",
            display: "flex",
            flexDirection: "column",
            marginTop: "0.5rem",
          }}
        >
          {section.heading && (
            <div style={{ display: "flex", alignItems: "center", margin: 0 }}>
              <div
                style={{
                  width: "8px",
                  height: "36px",
                  backgroundColor: !isSectionDisabled && sectionIsActive ? "#EB7E0E" : "transparent",
                  borderRadius: "0 4px 4px 0",
                }}
              ></div>
              <a
                href={isSectionDisabled ? "#" : section.path}
                onClick={(e) => {
                  if (isSectionDisabled) {
                    e.preventDefault();
                    setFeatureLockedModal(true);
                    return;
                  }
                  if (section.collapse) {
                    e.preventDefault();
                    toggleSection(section.heading);
                  }
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  cursor: isSectionDisabled ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  padding: "0.4rem 0.75rem",
                  margin: "0 0.75rem",
                  fontWeight: "400",
                  lineHeight: "24px",
                  borderRadius: "4px",
                  textDecoration: "none",
                  color: isSectionDisabled ? "#999" : !section.collapse && sectionIsActive ? "#fff" : "#000",
                  backgroundColor: isSectionDisabled ? "rgb(239, 238, 238)" :
                    !section.collapse && sectionIsActive
                      ? "rgba(72, 130, 87, 1)"
                      : "transparent",
                  opacity: isSectionDisabled ? 0.5 : 1,
                }}
              >
                <Box
                  component="img"
                  src={section.icon}
                  alt="icon"
                  sx={{
                    width: "20px",
                    height: "20px",
                    marginRight: "8px",
                    filter: isSectionDisabled ? "invert(0)" :
                      !section.collapse && sectionIsActive
                        ? "invert(1)"
                        : "invert(0)",
                  }}
                />
                <span
                  style={{
                    flexGrow: 1,
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {section.heading}
                </span>
                {section.collapse && !isSectionDisabled &&
                  (openSections[section.heading] ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  ))}
              </a>
            </div>
          )}

          {!isSectionDisabled && (
            <Collapse
              in={!section.collapse || openSections[section.heading]}
              timeout="auto"
              unmountOnExit
            >
              {section.subData?.map((item, subIndex) => {
                const isSubActive = location.pathname.startsWith(
                  item.path || item.url
                );
                const isSubDisabled = !isSubDataEnabled(item, section.heading);

                if (item.subHeading) {
                  return item.subcollapse ? (
                    <div key={subIndex}>
                      <div
                        onClick={() => {
                          if (isSubDisabled) {
                            setFeatureLockedModal(true);
                          } else {
                            toggleSection(item.subHeading);
                          }
                        }}
                        style={{
                          cursor: isSubDisabled ? "not-allowed" : "pointer",
                          display: "flex",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: "400",
                          justifyContent: "space-between",
                          alignItems: "center",
                          color: isSubDisabled ? "#999" : "#000",
                          padding: "0.4rem 0.75rem",
                          marginLeft: "2.5rem",
                          borderRadius: "4px",
                          backgroundColor: isSubDisabled ? "rgb(239, 238, 238)" : "transparent",
                          opacity: isSubDisabled ? 0.5 : 1,
                        }}
                      >
                        <div>
                          <Box
                            component="img"
                            src={item.icon}
                            alt="img"
                            sx={{
                              width: "20px",
                              height: "20px",
                              marginRight: "8px",
                            }}
                          />
                          <span>{item.subHeading}</span>
                        </div>
                        {!isSubDisabled && (openSections[item.subHeading] ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        ))}
                      </div>
                      {!isSubDisabled && (
                        <Collapse
                          in={openSections[item.subHeading]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <div style={{ marginTop: "0.5rem" }}>
                            {item.subChildren?.map((sub, i) => {
                              const isSubChildDisabled = !isSubChildEnabled(sub);
                              return renderLink(
                                sub.primary,
                                sub.icon,
                                sub.path,
                                location.pathname.startsWith(sub.path),
                                true,
                                isSubChildDisabled
                              );
                            })}
                          </div>
                        </Collapse>
                      )}
                    </div>
                  ) : (
                    renderLink(
                      item.subHeading,
                      item.icon,
                      item.path || item.url,
                      isSubActive,
                      true,
                      isSubDisabled
                    )
                  );
                }

                return renderLink(
                  item.primary,
                  item.icon,
                  item.path || item.url,
                  isSubActive,
                  true,
                  isSubDisabled
                );
              })}
            </Collapse>
          )}
        </div>
      );
    });

  return (
    <Box style={{ width: "100%" }}>
      <Box display="flex" justifyContent="center" p={2}>
        <img
          src={vajralog}
          alt="Logo"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/dashboard")}
        />
      </Box>
      <Divider />
      <div>{renderSidebarItems()}</div>
      <FeatureLockedModal
        open={featureLockedModal}
        onClose={() => setFeatureLockedModal(false)}
      />
    </Box>
  );
};

export default SidebarLayout;
